import { render, staticRenderFns } from "./IdoneitaGiudizioFinaleViewComponent.vue?vue&type=template&id=fa3d8b72"
import script from "./IdoneitaGiudizioFinaleViewComponent.vue?vue&type=script&lang=js"
export * from "./IdoneitaGiudizioFinaleViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports